import React from "react";
import ChangeTheme from "../themes/ChangeTheme";
import { FaShuffle, FaTrophy } from "react-icons/fa6";
import { IoExit } from "react-icons/io5";
import mkhLogo from "../../assets/images/mkh-logo.png";
import { useNavigate, useParams } from "react-router-dom";
import { usePartner } from "../../contexts/PartnerContext";

const MKHHeader = ({ theme, game, setGame }) => {
  const navigate = useNavigate();
  const partner = usePartner();
  const { partnerSlug } = useParams();
  // Keep the /partner/:slug prefix when navigating within a partner page.
  const partnerBase = partnerSlug ? `/partner/${partnerSlug}` : "";

  const nextTurn = () => {
    const currentTurnIndex = game.teams.findIndex((team) => team.currentTurn);
    const nextTurnIndex =
      currentTurnIndex === game.teams.length - 1 ? 0 : currentTurnIndex + 1;

    const updatedTeams = game.teams.map((team, index) => ({
      ...team,
      currentTurn: index === nextTurnIndex,
    }));

    setGame({ ...game, teams: updatedTeams });
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#29a6d6",
        }}
        className="w-full flex flex-row md:flex-row items-center justify-between p-2 md:pl-4 gap-1 h-[10vh]"
      >
        {/* Left Buttons */}
        <div className="flex flex-row items-center gap-2">
          <button
            className="flex items-center gap-2 text-white px-2 py-1 lg:px-3 lg:py-2 rounded-xl border-white border-2 font-bold uppercase text-sm md:text-base shadow hover:shadow-lg transition duration-150"
            type="button"
            onClick={() => navigate(partnerBase || "/")}
          >
            <IoExit className="w-5 h-5 md:w-6 md:h-6 transform rotate-180" />
            <h1 className="hidden md:block">الخروج</h1>
          </button>
          {/* End Game Button */}
          <button
            className="flex items-center gap-2 text-white px-2 py-1 lg:px-3 lg:py-2 rounded-xl border-white border-2 font-bold uppercase text-sm md:text-base shadow hover:shadow-lg transition duration-150"
            type="button"
            onClick={() =>
              navigate(`${partnerBase}/${game?.codeInfo?.code || "old"}/end`)
            }
          >
            <FaTrophy className="w-5 h-5 md:w-6 md:h-6" />
            <h1 className="hidden lg:block">إنهاء اللعبة</h1>
          </button>
          <ChangeTheme theme={theme} />
        </div>

        {/* Game Name */}
        <div className="text-white text-lg md:text-xl font-bold text-center ">
          {game?.name}
        </div>

        {/* Right Side */}
        <div className="flex flex-row items-center gap-2 ">
          {/* Skip Turn Button */}
          <button
            className="flex items-center gap-2 text-white px-2 py-1 lg:px-3 lg:py-2 rounded-full border-white border-2 text-sm md:text-base"
            onClick={nextTurn}
          >
            <FaShuffle className="w-3 h-3 md:w-4 md:h-4" />
            <h1>
              دور فريق: {game?.teams?.find((team) => team.currentTurn)?.name}
            </h1>
          </button>

          {/* Partner logo (left of the theme logo on partner pages) */}
          {partner?.logo && (
            <img
              className="h-10 w-10 lg:h-16 lg:w-16 object-contain"
              src={partner.logo}
              alt={partner.nameAr || partner.name}
            />
          )}
          {/* Logo */}
          <img
            className="h-10 w-10  lg:h-16 lg:w-16 object-contain text-white"
            src={mkhLogo}
            alt="تربع"
          />
        </div>
      </div>
    </>
  );
};

export default MKHHeader;
